export const BotTag = {
    HISTORY: "HistoryBot",
    ICEBERG: "IcebergBot",
    TELEGRAM: "TelegramBot",
    SIMULATION: "SimulationBot",
}